import React from 'react';
import PropTypes from 'prop-types';
import { itfMessage } from 'platform/shared/itf/content';

export const CustomItfAlert = ({
  creationDateFormatted,
  expirationDateFormatted,
}) =>
  itfMessage({
    status: 'success',
    headline: 'We have your intent to file',
    content: (
      <>
        <div>
          We have your intent to file a Survivors Pension and/or Dependency and
          Indemnity Compensation benefits (D.I.C.) application in our records.
          Your intent to file date is {creationDateFormatted}.
        </div>
        <p>
          <span>
            Submit your saved application by{' '}
            <strong>{expirationDateFormatted}</strong> to keep your intent to
            file date. If you don’t submit your application by this date, you
            can start a new application. But you may have a later effective date
            for benefits.
          </span>
        </p>
      </>
    ),
  });

CustomItfAlert.propTypes = {
  creationDateFormatted: PropTypes.string.isRequired,
  expirationDateFormatted: PropTypes.string.isRequired,
};
